import { render, staticRenderFns } from "./OfficialBbsList.vue?vue&type=template&id=71694c8f&scoped=true"
import script from "./OfficialBbsList.vue?vue&type=script&lang=ts"
export * from "./OfficialBbsList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OfficialBbsList.vue?vue&type=style&index=0&id=71694c8f&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71694c8f",
  "0fb9d6b2"
  
)

export default component.exports